
export const contactUsSubjectsListData = () => {
    return {
        options: [
            { value : "Technical", label : "Technical"},
            { value : "Registration", label : "Registration"},
            { value : "Other", label : "Other"}
        ]
    }
};